/**
 * Represents the type of the Status.
 */
export const enum Status {
  Pending = 'pending',
  Approved = 'approved',
}

export interface AppTeam {
  /** The AppTeam id. */
  id?: number;
  /** The role id for AppTeam. */
  roleId: number;
  /** The user id for AppTeam. */
  userId: number;
  /** The app id for AppTeam. */
  appId: number;
  /** The status for AppTeam
   * - default value is pending
   */
  status: Status;
}
